module.exports = __webpack_public_path__ + "static/media/col_camp_sail_boats.c3106161.jpg";